import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */

import { css, jsx } from '@emotion/react'; // eslint-disable-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { useIsFlexElementWrapped } from '../../../hooks/useIsFlexElementWrapped';
var container = css({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  gap: "var(--ds-space-100, 8px)",
  paddingTop: 0
});
var standardRootContainer = css({
  paddingTop: "var(--ds-space-150, 12px)"
});
var secondLevelContainer = css({
  marginLeft: 'auto'
});
var compactSecondaryButtonsContainer = css({
  display: 'flex',
  alignItems: 'center',
  gap: "var(--ds-space-100, 8px)",
  // FIXME: Should be removed here. Discuss with the designer and try to avoid style hacking!!!
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '*:has(> svg)': {
    height: '18px',
    width: '18px'
  }
});
/**
 * Layout for action buttons.
 *
 * Do not put any additional logic besides layout logic here, because the layout logic is kind of complex,
 * and  it will be hard to maintain it in the future!
 */
export function ActionButtonsLayout(_ref) {
  var _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'standard' : _ref$mode,
    cancelButton = _ref.cancelButton,
    primaryButtons = _ref.primaryButtons,
    secondaryButtons = _ref.secondaryButtons;
  // The Discard button should be the last when there are two lines of buttons.
  //
  // We can't do it just by CSS (for example, by order prop), because CSS order doesn't
  // affect the tab order.
  // And we can't use tabindex, because tabindex is global and change order of all elements.
  // That's why we need to render the Discard button in different places in the DOM,
  // based on the number of lines. Stupid but works=(
  //
  // Also, we can't determinate the line count based on container width
  // because the amount buttons can be different.
  // That's why we use the useIsFlexElementWrapped hook to determine the line count.
  //
  // See more why CSS order and tabindex don't work: https://tink.uk/flexbox-the-keyboard-navigation-disconnect/

  var _useIsFlexElementWrap = useIsFlexElementWrapped(),
    _useIsFlexElementWrap2 = _slicedToArray(_useIsFlexElementWrap, 2),
    setRootContainerElement = _useIsFlexElementWrap2[0],
    isRootContainerWrapped = _useIsFlexElementWrap2[1];
  var _useIsFlexElementWrap3 = useIsFlexElementWrapped(),
    _useIsFlexElementWrap4 = _slicedToArray(_useIsFlexElementWrap3, 2),
    setSecondLevelContainerElement = _useIsFlexElementWrap4[0],
    isSecondLevelContainerWrapped = _useIsFlexElementWrap4[1];
  return jsx("div", {
    ref: setRootContainerElement,
    css: [container, mode === 'standard' && standardRootContainer]
  }, !isRootContainerWrapped && mode === 'compact' && jsx("div", {
    css: compactSecondaryButtonsContainer
  }, secondaryButtons), jsx("div", {
    ref: setSecondLevelContainerElement,
    css: [container, secondLevelContainer]
  }, !isSecondLevelContainerWrapped && cancelButton, (primaryButtons || mode === 'standard' && secondaryButtons) && jsx("div", {
    css: container
  }, mode === 'standard' && secondaryButtons, primaryButtons), isSecondLevelContainerWrapped && cancelButton), isRootContainerWrapped && mode === 'compact' && jsx("div", {
    css: compactSecondaryButtonsContainer
  }, secondaryButtons));
}